import './search.scss';
import '../../slider.scss';

import { createInstantSearchBlock } from '@boost-sd/theme/core/blocks/search';

const instantSearchBlock = createInstantSearchBlock();

instantSearchBlock.render();
